import { ProgramEventSuggestionCreateParams } from '@citruscamps/citrus-client'
import { faMagicWandSparkles } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { FeatureFlag } from '../FeatureFlag/FeatureFlag'
import { LoadingButton } from '../LoadingButton/LoadingButton'
import { Tooltip } from '../Tooltip/Tooltip'
import { useSuggestedText } from './hooks/useSuggestedText'

interface IProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  suggestion: ProgramEventSuggestionCreateParams
  tooltipText?: string
  eventId?: string
  programId?: string
}

export const SuggestTextInput = ({
  suggestion,
  tooltipText,
  eventId,
  programId,
  className,
  ...props
}: IProps) => {
  const { ref, hasSuggested, handleSubmit } = useSuggestedText({
    onInputChange: props.onChange,
    onInputBlur: props.onBlur,
  })
  const _className = ['form-control', hasSuggested ? 'typing' : '', className]
    .filter(Boolean)
    .join(' ')
    .trim()

  return (
    <div className="input-group">
      <input ref={ref} type="text" className={_className} {...props} />
      <FeatureFlag flagKey="suggestions_enabled">
        <Tooltip
          title={tooltipText || 'Automatically generate text for this field.'}
          placement="left"
        >
          <LoadingButton
            className="btn btn-outline-primary"
            type="button"
            onClick={async () => {
              await handleSubmit(suggestion)
            }}
          >
            <FontAwesomeIcon icon={faMagicWandSparkles} />
          </LoadingButton>
        </Tooltip>
      </FeatureFlag>
    </div>
  )
}
